<template>
  <div class="supra-care">
    <!-- Conteneur principal pour organiser les sections -->
    <div class="main-content">
      <!-- Section Compléments Alimentaires -->
       
      <section class="complements-alimentaires">
   
        <div class="description">
          <h2>Compléments Alimentaires</h2>
          <p>
            Dans notre <strong>Société SupraCare</strong>, nous proposons une gamme
            variée de compléments alimentaires de haute qualité, soigneusement formulés
            pour répondre à vos besoins nutritionnels spécifiques. Nos suppléments
            sont conçus pour soutenir votre bien-être général et favoriser une
            alimentation équilibrée.
          </p>
          <p>
            Que vous recherchiez des vitamines essentielles, des minéraux, des
            antioxydants ou d’autres nutriments bénéfiques, nos produits sont
            élaborés avec des ingrédients de qualité supérieure pour vous aider
            à maintenir une santé optimale.
          </p>
          <p>
            Chaque complément alimentaire que nous offrons est soumis à des normes
            rigoureuses de contrôle de la qualité, garantissant ainsi leur
            efficacité et leur sécurité.
          </p>
          
             <div class="image">
          <img :src="require('@/assets/vita4.png')" alt="Supplements" />
        </div>
        </div>
      </section>

      
      <!-- Section Vitamines & Minéraux -->
      <section class="vitamines-mineraux">
        <h2>Vitamines & Minéraux</h2>
        <ul class="tabs">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: activeTab === index }"
            @click="activeTab = index" 
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="tab-content">
          <div v-if="tabs[activeTab]">
            <p>{{ tabs[activeTab].content }}</p>
            <img
              v-if="tabs[activeTab].image"
              :src="tabs[activeTab].image"
              :alt="tabs[activeTab].title"
              width="300"
              height="300"
            />
          </div>
        </div>
          <router-link to="/shop" class="shop-button">
    Shop en Ligne
  </router-link>
      </section>
    </div>

    <!-- Section Blurbs -->
    <section class="blurbs">
      <h2>Vitamines & Minéraux</h2>
      <div class="blurbs-container">
        <div v-for="(blurb, index) in blurbs" :key="index" class="blurb">
          <img :src="blurb.image" :alt="blurb.title" />
          <h4>{{ blurb.title }}</h4>
          <p>{{ blurb.description }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name:'Vitamines-minireauxI',
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          title: "Levure de Biére",
          content: "Levure de bière (Saccharomyces cerevisiae), agent de charge : cellulose microcristalline, anti-agglomérant : stéarate de magnésium",
          image: require('@/assets/vit.png'),
        },
        {
          title: "Tonus & Vitalité",
          content: "Fer, Acide folique, B12, et la vitamine C. Boîte de 2 blisters, 30 gélules.",
        },
        {
          title: "Sirop de Toux 125ml, Adulte",
          content: "Formule adaptée pour soulager la toux.",
        },
        {
          title: "Stimulant d'appétit sirop 150ml",
          content: "Stimulant naturel pour améliorer l'appétit.",
        },
        {
          title: "CA Anti-inflammatoire 30 gélules",
          content: "Curcuma 200mg, Harpagophytum 100mg, Gingembre 40mg.",
        },
        {
          title: "Magnésium Marin",
          content: "175mg Magnésium, 1.8mg Mélatonine, 2mg B6.",
        },
        {
          title: "Multivitamines 90 CP",
          content: "Multivitamines pour un soutien complet.",
        },
      ],
      blurbs: [
        {
          title: "Vitamines & Minéraux",
          description: "VITAMINE B12",
          image: require('@/assets/b12.png'), 
        },
        {
          title: "Vitamines & Minéraux",
          description: "VITAMINE C",
          image: require('@/assets/c vantis.png'), 

        },
        {
          title: "Vitamines & Minéraux",
          description: "VITAMINE D",
          image: require('@/assets/vitasol d.png'),  
        },
      ],
    };
  },
};
</script>

<style scoped>
/* ======== MODE CLAIR ======== */
.supra-care {
  font-family: "Roboto", Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  padding: 20px;
  background: #f8f9fa;
  transition: background 0.3s, color 0.3s;
}

/* Conteneur principal */
.main-content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 40px;
}

/* Section Compléments Alimentaires */
.complements-alimentaires {
  flex: 2;
  align-items: center;
  gap: 10px;
  padding: 60px;
}

.complements-alimentaires .description h2 {
  font-family: 'Oswald', Helvetica, Arial, Lucida, sans-serif;
  font-size: 30px;
  color: #000;
  letter-spacing: 3px;
  line-height: 1.2em;
}

.complements-alimentaires .description p {
  margin-bottom: 10px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.complements-alimentaires .image {
  flex: 1;
  margin: 80px;
}

.complements-alimentaires .image img {
  max-width: 80%;
}

/* Section Vitamines & Minéraux */
.vitamines-mineraux {
  flex: 1;
  padding: 20px;
}

.vitamines-mineraux h2 {
  font-size: 1.8em;
  color: #00998B;
  margin-bottom: 20px;
}

.tabs {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-right: 2px solid #ddd;
  padding: 0;
  margin-bottom: 20px;
}

.tabs li {
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-right: none;
  border-radius: 10px 0 0 20px;
  background: #f8f9fa;
  transition: background 0.3s, color 0.3s;
}

.tabs li.active {
  font-weight: bold;
  background: #00998B;
  color: #fff;
}

.tabs li:hover {
  background: #003d80;
  color: #fff;
}

.tab-content {
  margin-left: 20px;
}

.tab-content img {
  max-width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.shop-button {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background: #00998B;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1em;
  transition: background 0.3s;
}

.shop-button:hover {
  background: #003d80;
}

/* Section Blurbs */
.blurbs {
  padding: 10px;
  text-align: center;
}

.blurbs h2 {
  font-family: 'Oswald', Helvetica, Arial, Lucida, sans-serif;
  text-transform: uppercase;
  font-size: 45px;
  letter-spacing: 3px;
  line-height: 1.4em;
}

.blurbs-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  margin: 60px;
}

.blurb {
  flex: 1 1 calc(33.333% - 20px);
  padding: 0px;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

.blurb:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.blurb img {
  max-width: 100px;
  margin-bottom: 10px;
}

.blurb h4 {
  font-size: 1.2em;
  margin: 10px 0;
  color: #00998B;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .main-content { flex-direction: column; gap: 30px; }
  .complements-alimentaires { padding: 40px; }
  .complements-alimentaires .image { margin: 40px auto; }
  .complements-alimentaires .image img { max-width: 90%; }
  .blurbs-container { gap: 15px; margin: 40px 10px; }
  .blurb { flex: 1 1 calc(50% - 10px); }
}

@media (max-width: 768px) {
  .main-content { gap: 20px; }
  .complements-alimentaires { padding: 20px; }
  .complements-alimentaires .description h2 { font-size: 24px; }
  .complements-alimentaires .description p { font-size: 14px; }
  .vitamines-mineraux h2 { font-size: 1.5em; }
  .tabs { flex-direction: row; overflow-x: auto; border-right: none; border-bottom: 2px solid #ddd; }
  .tabs li { padding: 8px 15px; font-size: 0.9em; border-radius: 5px; }
  .blurbs-container { flex-direction: column; margin: 20px; }
  .blurb { flex: 1 1 100%; }
}

@media (max-width: 480px) {
  .complements-alimentaires { padding: 10px; }
  .complements-alimentaires .description h2 { font-size: 20px; }
  .complements-alimentaires .description p { font-size: 12px; }
  .blurbs h2 { font-size: 30px; }
  .blurb img { max-width: 80px; }
  .blurb h4 { font-size: 1em; }
}

/* ======== 🌙 MODE SOMBRE ======== */
@media (prefers-color-scheme: dark) {
  .supra-care {
    background: #0b0f14;
    color: #e6edf1;
  }

  .complements-alimentaires .description h2,
  .vitamines-mineraux h2,
  .blurb h4 {
    color: #73d8cf;
  }

  .tabs li {
    background: #18222e;
    border-color: #222;
    color: #e6edf1;
  }

  .tabs li.active {
    background: #00998B;
    color: #fff;
  }

  .tabs li:hover {
    background: #007a73;
  }

  .shop-button {
    background: #00998B;
    color: #fff;
  }

  .shop-button:hover {
    background: #00bfa5;
  }

  .blurb {
    background: #1a2532;
    box-shadow: 0 4px 10px rgba(0,0,0,0.7);
  }

  .blurb:hover {
    box-shadow: 0 6px 12px rgba(255,255,255,0.1);
  }

  .blurb h4 {
    color: #00bfa5;
  }

  .blurbs h2 {
    color: #aef7f0;
  }
}
</style>
